var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loaded),
      expression: "loaded"
    }],
    staticClass: "order-detail"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showShareMask),
      expression: "showShareMask"
    }],
    staticClass: "toshare",
    on: {
      "click": _vm.onShareMaskClick
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/toshare.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }), _vm._v(" "), _c('div', {
    staticClass: "section-title"
  }, [_vm._v("\n    订单编号\n    "), _c('span', [_vm._v(_vm._s(_vm.order.order_no))]), _vm._v(" "), _c('div', {
    staticClass: "share",
    class: {
      yellow: !_vm.order.is_shared
    }
  }, [_vm._v(_vm._s(_vm.order.share_status_title))])]), _vm._v(" "), _c('div', {
    staticClass: "info-card"
  }, [_c('ul', {
    staticClass: "info-cont"
  }, [_c('li', [_c('span', {
    staticClass: "label"
  }, [_vm._v("订单状态")]), _vm._v(" "), _c('span', {
    staticClass: "blue"
  }, [_vm._v(_vm._s(_vm.order.order_status_title))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "label"
  }, [_vm._v("下单时间")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.order.create_time))])])]), _vm._v(" "), _c('div', {
    staticClass: "subtitle-info top-line top-solid-line"
  }, [_vm._v("套餐信息")]), _vm._v(" "), _c('ul', {
    staticClass: "info-cont"
  }, [_c('li', [_c('span', {
    staticClass: "label"
  }, [_vm._v("套餐名称")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.order.product_pkg_title))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "label"
  }, [_vm._v("套餐价格")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.order.order_price) + "元")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "label"
  }, [_vm._v("抵扣金额")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.order.dikou_amount) + "元")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "label"
  }, [_vm._v("应付金额")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.order.pay_price) + "元")])]), _vm._v(" "), (!_vm.order.has_signed) ? _c('li', [_c('span', {
    staticClass: "label"
  }, [_vm._v("服务时长")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.order.service_period) + " " + _vm._s(_vm.order.granularity == 2 ? '天' : '个月'))])]) : _vm._e(), _vm._v(" "), (_vm.order.has_signed) ? _c('li', [_c('span', {
    staticClass: "label"
  }, [_vm._v("服务时间")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.order.service_start_date) + " 至 " + _vm._s(_vm.order.service_end_date))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "subtitle-info top-line top-solid-line"
  }, [_vm._v("购买人信息")]), _vm._v(" "), _c('ul', {
    staticClass: "info-cont"
  }, [_c('li', [_c('span', {
    staticClass: "label"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.order.customer_name))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "label"
  }, [_vm._v("手机号码")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.order.security_mobile || '无'))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "label"
  }, [_vm._v("回执编号")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.order.survey_code || '无'))])])]), _vm._v(" "), (_vm.payments.length > 0) ? _c('div', {
    staticClass: "subtitle-info top-line top-solid-line"
  }, [_vm._v("付款信息")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.payments), function(item, index) {
    return _c('order-pay-item', {
      key: item.payment_id,
      attrs: {
        "payment": item,
        "role": "customer",
        "last": index == _vm.payments.length - 1
      }
    })
  }), _vm._v(" "), (_vm.canTrans) ? _c('div', {
    staticClass: "subtitle-info top-line top-solid-line"
  }, [_vm._v("查账信息相关")]) : _vm._e(), _vm._v(" "), (_vm.canTrans) ? _c('ul', {
    staticClass: "info-cont"
  }, [_c('li', {
    on: {
      "click": _vm.toTransFillIn
    }
  }, [_c('a', {
    staticClass: "yellow",
    attrs: {
      "href": "javascript:void(0);"
    },
    domProps: {
      "textContent": _vm._s(_vm.transTips)
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "subtitle-info top-line top-solid-line"
  }, [_vm._v("分享链接")]), _vm._v(" "), _c('ul', {
    staticClass: "info-cont"
  }, [_c('li', [_c('a', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.share.link),
      expression: "share.link",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopied),
      expression: "onCopied",
      arg: "success"
    }],
    staticClass: "blue",
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("复制链接分享给客户")])])])], 2)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.0.2@vue-loader/lib/template-compiler?{"id":"data-v-97b1166a","hasScoped":true}!./~/_vue-loader@13.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/order/OrderDetail.vue
// module id = 255
// module chunks = 0